export const FETCH_ORDER_CALCULATE_PENDING = 'FETCH_ORDER_CALCULATE_PENDING';
export const FETCH_ORDER_CALCULATE_REJECTED = 'FETCH_ORDER_CALCULATE_REJECTED';
export const FETCH_ORDER_CALCULATE_FULFILLED =
  'FETCH_ORDER_CALCULATE_FULFILLED';



// WEBPACK FOOTER //
// ./src/constants/orderCalculateQuestions.js